<template>
  <DropdownComponent
    :close-on-click="false"
    v-bind="$attrs"
    :dropdown-wrapper="usePortal ? portal : 'div'"
    @visible="() => $emit('refetch')"
    class="action-dropdown"
  >
    <template>
      <ButtonComponent :label="label" :icon="icon" :theme="theme" />
    </template>
    <template #dropdown>
      <ActionList :value="value" :query="query" v-on="$listeners">
        <template #top>
          <slot name="top" />
        </template>
        <template #bottom>
          <slot name="bottom" />
        </template>
      </ActionList>
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import { ButtonComponent } from 'vue-elder-button'
import ActionList from './List'
import Portal from '@/components/Portal'

export default {
  name: 'ActionDropdown',
  props: {
    label: {
      type: String,
      default() {
        return this.$tc('action', 2)
      },
    },
    icon: {
      type: Array,
      default() {
        return ['fal', 'bullseye-pointer']
      },
    },
    theme: {
      type: String,
      default: 'default',
    },
    value: Array,
    query: Object,
    usePortal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      portal: Portal,
    }
  },
  components: {
    DropdownComponent,
    ButtonComponent,
    ActionList,
  },
}
</script>
